// extracted by mini-css-extract-plugin
export default {"toggle":"A8qyg4SQaJii2RPd_ZOC"};